import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary via-secondary to-primary text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE2YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00em0wIDI0YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00ek0xMiAxNmMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHptMCAyNGMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 md:mb-4">
            Ready to Transform Your Business?
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto">
            Join 678+ organizations that trust InChi Solutions Pvt Ltd for their comprehensive business needs.
            Let's discuss how we can help you achieve your goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 text-center">
            <Icon name="Clock" size={32} className="mx-auto mb-3 text-accent" />
            <div className="text-xl md:text-2xl font-bold mb-2">24/7</div>
            <div className="text-sm md:text-base text-white/80">Support Available</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 text-center">
            <Icon name="Shield" size={32} className="mx-auto mb-3 text-accent" />
            <div className="text-xl md:text-2xl font-bold mb-2">100%</div>
            <div className="text-sm md:text-base text-white/80">Compliance Guaranteed</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 text-center">
            <Icon name="TrendingUp" size={32} className="mx-auto mb-3 text-accent" />
            <div className="text-xl md:text-2xl font-bold mb-2">40%</div>
            <div className="text-sm md:text-base text-white/80">Average ROI Increase</div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            variant="default"
            size="lg"
            iconName="Calendar"
            iconPosition="left"
            className="bg-accent hover:bg-accent/90 text-white w-full sm:w-auto"
          >
            Schedule Free Consultation
          </Button>
          <Button
            variant="outline"
            size="lg"
            iconName="Phone"
            iconPosition="left"
            className="bg-white/10 hover:bg-white/20 text-white border-white/30 w-full sm:w-auto"
          >
            Call: +91 98765 43210
          </Button>
        </div>

        <div className="mt-8 md:mt-12 text-center">
          <p className="text-xs md:text-sm text-white/70 mb-4">
            Trusted by leading organizations across industries
          </p>
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
            {['ISO 9001:2015', 'GDPR Compliant', 'Industry Leader', 'Award Winner']?.map((badge) => (
              <div
                key={badge}
                className="flex items-center gap-2 px-3 md:px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-xs md:text-sm"
              >
                <Icon name="Award" size={16} />
                <span className="whitespace-nowrap">{badge}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;